import { marketplace, money, promoCode as promoTools } from '@sellpy/commons'
import { getRegion, validShippingCountries } from '../../common/region/region'

export const calculateSelectedContainersPrices = ({ nrOfBags, containerPrice, promoCode }) =>
  promoTools.applyBagPromoCode({
    promoCode,
    nrOfBags,
    containerPrice,
    region: getRegion()
  })

export const calculateExpressAssortmentPrice = ({ expressAssortmentPrice, promoCode }) => {
  if (!expressAssortmentPrice) {
    return { amount: 0, currency: marketplace.CURRENCY[getRegion()] }
  }
  return promoTools.applyExpressAssortmentPromoCode({
    promoCode,
    expressAssortmentPrice
  })
}

export const calculateTotalAmount = ({
  nrOfBags,
  promoCode,
  containerPrice,
  isExpressAssortment,
  expressAssortmentPrice
}) => {
  if (!nrOfBags) return
  const totalContainerPricesStandard = money.toSubUnit(
    money.add(...calculateSelectedContainersPrices({ nrOfBags, containerPrice, promoCode }))
  )
  if (isExpressAssortment && expressAssortmentPrice) {
    const expressAssortmentPrices = calculateExpressAssortmentPrice({
      expressAssortmentPrice,
      promoCode
    })
    const totalPriceWithExpress = money.add(totalContainerPricesStandard, expressAssortmentPrices)
    return totalPriceWithExpress
  }
  return totalContainerPricesStandard
}

// If user has incorrect address for region, only fill in non-postal information and add default region
// zipCode is not provided, as it is appended in checkout through form but not in Cart content
export const getPresetAddress = ({ user }) => {
  const address = user?.address
  // Only default country for regions with few countries, to reduce user errors
  const defaultCountry = validShippingCountries.length < 4 ? validShippingCountries[0] : undefined
  if (!address) {
    return { country: defaultCountry }
  }
  if (validShippingCountries.includes(address.country)) {
    return { ...address }
  } else {
    return {
      firstName: address.firstName,
      lastName: address.lastName,
      phone: address.phone,
      country: defaultCountry
    }
  }
}
